
export const addressPoints = [
  { key: "airedatos", latitude: -11.97869949843802, longitude: -77.0015485624854 },
  { key: "airedatosSRCO", latitude: -12.104012431996967, longitude: -76.95982523850891 }
];
